import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import "../../styles/user/banner/email_verification.css";
import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { getTeamRoleKey } from "../../utils/getUserTeamRoleKey";

function ResendVerificationEmailButton() {
  const [isDisabled, setIsDisabled] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const handleClick = async () => {
    setIsDisabled(true);
    try {
      const baseUrl = process.env.REACT_APP_BASE_URL;
      let user = JSON.parse(Cookies.get("user"));
      let teamKey = getTeamRoleKey(user.team_roles, "admin");
      const newConfig = {
        "Content-Type": "application/json",
        headers: {
          Team: teamKey,
          Authorization: `Bearer ${user.access_token}`,
        },
      };
      await axios.post(
        baseUrl + "/api/auth/resend-verification-mail",
        {},
        newConfig
      );
      toast.success("Verification email sent successfully!");
      startCountdown(120); // 2 minutes
    } catch (error) {
      toast.error(
        error?.response?.data?.message ??
          "Failed to resend verification email. Please try again."
      );
      console.log(error);
      setIsDisabled(false);
    }
  };

  const startCountdown = (seconds) => {
    setCountdown(seconds);
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setIsDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  return (
    <button
      onClick={handleClick}
      disabled={isDisabled}
      className="banner_notification__resend_button"
    >
      <span>
        {isDisabled ? `Wait ${countdown}s` : "Resend Verification Email"}
      </span>
    </button>
  );
}

export default function VerifyEmailBanner() {
  const hasVerifiedEmail = !!useSelector(
    (state) => state?.user?.user?.email_verified_at
  );
  const isLoggedIn = !!useSelector((state) => state?.user?.user?.id);

  return isLoggedIn && !hasVerifiedEmail ? (
    <div className="banner_notification__email_verification">
      PLEASE CHECK YOUR INBOX FOR A VERIFICATION EMAIL.
      <ResendVerificationEmailButton />
    </div>
  ) : (
    ""
  );
}
